import React from "react";
import CampaignRegistrationList from "./campaignRegistrationList/CampaignRegistrationList";

const CampaignRegistration = () => {
  return <CampaignRegistrationList />;
};

export default CampaignRegistration;
